const COLLECTION = "keywords";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  return {
    id: snap.id,
    ...snap.data()
  };
};

function KeywordsMixin() {
  return {
    async saveKeywords({ category, keywords, search }) {
      const ref = await this.collection(COLLECTION).add({ category, keywords, search });
      const keywordsData = {
        id: ref.id,
        ...{ category, keywords, search }
      };
      return keywordsData;
    },

    async getKeywordsBySearch({ search }) {
      return await this.collection(COLLECTION)
        .where("search", "==", search)
        .get()
        .then((querySnapshot) => populateSnapshots(querySnapshot));
    },

    async getKeywordsByJobTitle({ jobTitle }) {
      return await this.collection(COLLECTION)
        .where("jobTitle", "==", jobTitle)
        .get()
        .then((querySnapshot) => populateSnapshots(querySnapshot));
    }
  };
}

module.exports = KeywordsMixin;
